import { Grid, TextField, Button, Divider } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import Modal from 'react-modal';
import CloseIcon from '@material-ui/icons/Close';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import _keyBy from 'lodash/keyBy';
import _get from 'lodash/get';
import JourneyAssignCardV2 from '../journey/JourneyAssignCardV2';
import Theme from '../ui/Theme';
import {
  getAssignedJourneys,
  getCheckedAssignedJourneys,
  showProgress,
  getDealershipAssignedJourneys,
} from '../../redux/actions/DealershipActions';
import service from '../../apis/service';
import { ErrorToast, notifySuccess } from '../utils/Utils';
import AssignJourneyToAllConfirmation from './AssignJourneyToAllConfirmation';
import { apiEndpoints } from '../../constants/apiEndpoints';

const WIDTH = '600px';

const useStyles = makeStyles(() => ({
  frameStyle: {
    width: WIDTH,
    height: '45px',
  },
  contentStyle: {
    width: WIDTH,
    height: '349px',
    marginLeft: `calc(50% - ${WIDTH}/2)`,
    marginTop: '20px',
  },
  titleFrame: {
    width: '283px',
    height: '45px',
  },
  searchFrame: {
    width: '270px',
    height: '49px',
    background: Theme.palette.secondary.main,
    marginLeft: '2%',
  },

  closeIcon: {
    width: '26px',
    height: '26px',
    borderRadius: '50%',
    backgroundColor: Theme.palette.secondary.main,
    padding: '8px',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.4)',
    },
  },
  filterIcon: {
    width: '73px',
    height: '49px',
    backgroundColor: '#FAFAFA',
    cursor: 'pointer',
    padding: '8px',
    '&:hover': {
      backgroundColor: 'FAFAFA',
    },
  },
  titleText: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '18px',
    lineHeight: '22px',
    color: '#000000',
  },

  searchText: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '14px',
    lineHeight: '0px',
    color: 'black',
  },
  mainContent: {
    background: Theme.palette.secondary.main,
    alignItems: 'center',
  },
  cancelButton: {
    width: '111px',
    height: '42px',
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '14px',
    lineHeight: '17px',
    textAlign: 'center',
  },
  submitButton: {
    width: '216px',
    height: '42px',
    marginLeft: '20px',
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '14px',
    lineHeight: '17px',
    textAlign: 'center',
  },
  titleSubText: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '12px',
    lineHeight: '15px',
    marginTop: '8px',
    color: 'rgba(0, 0, 0, 0.4)',
  },
}));
const AssignJourneyDept = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const roleID = useSelector((state) => state.getSelectedRoleID);
  const departmentID = useSelector((state) => state.getDepartment);
  const dealershipID = useSelector((state) => state.getDealershipID);
  const roleListDept = useSelector((state) => state.getRoleList.rolelist);
  const checkedJourneys = useSelector((state) => state.getCheckedJourneys.checkedJourneys);
  const mandatoryJourneys = useSelector((state) => state.getMandatoryJourneys.mandatoryJourneys);
  const assignedJourneys = useSelector((state) => state.getAssignedJourneys.assignedJourneys);
  const dealershipAssignedJourneys = useSelector(
    (state) => state.getDealershipAssignedJourneys.dealershipAssignedJourneys,
  );
  const assignedJourneysMap = _keyBy(assignedJourneys, 'id');

  const [viewAssign, setViewAssign] = useState(props.open);
  const [searchVal, setSearchVal] = useState('');
  const [filterArray, setFilterArray] = useState([]);

  const [viewConfirmation, setViewConfirmation] = useState(false);

  let dispatchSelectedJourney = [];
  const journeylist = props.jList;
  const selectedJourneys = [];

  useEffect(() => {
    if (journeylist !== undefined) {
      setFilterArray(journeylist);
    } else {
      setFilterArray([]);
    }
  }, []);
  useEffect(() => {
    selectedJourneys.forEach((data, key) => {
      if (mandatoryJourneys.indexOf(data.id) > -1) {
        selectedJourneys[key].id = data.id;
        selectedJourneys[key].mandatory = true;
      } else {
        selectedJourneys[key].id = data.id;
        selectedJourneys[key].mandatory = false;
      }
    });
  }, [mandatoryJourneys]);

  const handleClosePopup = () => {
    setViewAssign(false);
    dispatch(getDealershipAssignedJourneys('reset', {}));
    props.close();
  };
  const submit = async () => {
    if (selectedJourneys) {
      const finalJourneys = selectedJourneys.map((sj) => {
        const tempJourney = { ...sj };
        if (tempJourney.id in dealershipAssignedJourneys) {
          tempJourney.dealershipAssigned = _get(
            dealershipAssignedJourneys,
            `${tempJourney.id}.dealershipAssigned`,
            !!assignedJourneysMap[tempJourney.id]?.dealershipAssigned,
          );
          if (tempJourney.dealershipAssigned) {
            tempJourney.startDate = moment(dealershipAssignedJourneys[tempJourney.id].startDate).format('YYYY-MM-DD');
            tempJourney.endDate = moment(dealershipAssignedJourneys[tempJourney.id].endDate).format('YYYY-MM-DD');
          }
        }
        return tempJourney;
      });
      dispatch(showProgress(true));
      const finObj = {
        dealershipId: dealershipID,
        departmentId: departmentID,
        departmentRoleId: roleID,
        journeys: finalJourneys,
      };

      await service
        .post(apiEndpoints.DEALER_ASSIGN_JOURNEY, finObj)
        .then((response) => {
          dispatchSelectedJourney = [];
          selectedJourneys.forEach((data) => {
            const assJour = response.find((o) => o.id === data.id);
            if (assJour !== undefined) {
              dispatchSelectedJourney.push(assJour);
            }
          });
          dispatch(getAssignedJourneys(dispatchSelectedJourney));
          dispatch(getDealershipAssignedJourneys('reset', {}));
          dispatch(showProgress(false));
          props.close();
          notifySuccess('Saved Successfully');
        })
        .catch((error) => {
          ErrorToast(error);
          props.close();
          dispatch(showProgress(false));
        });
    }
  };
  const handleSearchChange = (e) => {
    const input = e.target.value;
    setSearchVal(input);
    const filteredArray = input
      ? journeylist.filter((item) => item.title.toLowerCase().includes(input.toLowerCase()))
      : journeylist;
    setFilterArray(filteredArray);
    const checkedArray = [];
    const checkedValues = [];
    const selectedCheck = [];
    journeylist?.forEach((data, key) => {
      assignedJourneys?.forEach((data1) => {
        if (data.id === data1.id) {
          selectedCheck.push(key);
        }
      });
    });
    selectedCheck?.forEach((data) => {
      if (journeylist) {
        checkedArray.push(journeylist[data]);
      }
    });

    const intersection = filteredArray.filter((item1) => checkedArray.some((item2) => item1.id === item2.id));

    intersection.forEach((data) => {
      filteredArray.forEach((data1, key1) => {
        if (data.id === data1.id) {
          checkedValues.push(key1);
        }
      });
    });
    dispatch(getCheckedAssignedJourneys(checkedValues));
  };

  checkedJourneys?.forEach((data) => {
    if (journeylist) {
      selectedJourneys.push({
        id: data,
        mandatory: false,
      });
      dispatchSelectedJourney.push(journeylist.find((o) => o.id === data));
    }
  });
  selectedJourneys.forEach((data, key) => {
    if (mandatoryJourneys.indexOf(data.id) > -1) {
      selectedJourneys[key].id = data.id;
      selectedJourneys[key].mandatory = true;
    } else {
      selectedJourneys[key].id = data.id;
      selectedJourneys[key].mandatory = false;
    }
  });

  return (
    <div>
      <Modal
        onRequestClose={() => false}
        shouldCloseOnEsc={false}
        isOpen={viewAssign}
        style={{
          overlay: {
            backgroundColor: 'hsla(50, 33%, 25%, 0.35)',
          },
          content: {
            padding: '20px 16px 28px',
            width: WIDTH,
            height: '502px',
            background: '#FFFFFF',
            position: 'absolute',
            left: '50%',
            top: '50%',
            transform: 'translate(-50%, -50%)',
            overflow: 'hidden',
          },
        }}
      >
        <Grid container direction="column">
          <Grid item className={classes.frameStyle}>
            <Grid container direction="row" justifyContent="space-between">
              <Grid item className={classes.titleFrame}>
                <Grid container direction="column">
                  <Grid item className={classes.titleText}>
                    Assign New Journeys
                  </Grid>
                  <Grid item className={classes.titleSubText}>
                    To {roleID === 0 ? 'All' : roleListDept?.find((x) => x.id === roleID).name}
                  </Grid>
                </Grid>
              </Grid>
              <Grid item onClick={handleClosePopup}>
                <CloseIcon className={classes.closeIcon} />
              </Grid>
            </Grid>
          </Grid>
          <Grid item className={classes.contentStyle}>
            <Grid
              container
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              className={classes.mainContent}
            >
              <Grid item>
                <TextField
                  id="searchId"
                  name="search"
                  required
                  autoComplete="off"
                  autoSave="off"
                  onChange={handleSearchChange}
                  placeholder="Search"
                  value={searchVal}
                  InputProps={{
                    disableUnderline: true,
                    className: classes.searchFrame,
                  }}
                />
              </Grid>
            </Grid>
            <JourneyAssignCardV2 listVal={filterArray} />
          </Grid>
          <Divider
            style={{
              width: WIDTH,
              marginTop: '30px',
              marginBottom: '24px',
            }}
          />
          <Grid item>
            <Grid container direction="row" justifyContent="center">
              <Grid item>
                <Button variant="contained" onClick={props.close} disableElevation className={classes.cancelButton}>
                  Cancel
                </Button>
              </Grid>
              <Grid item>
                <Button
                  variant="contained"
                  color="primary"
                  className={classes.submitButton}
                  onClick={() => {
                    if (roleID !== 0) {
                      submit();
                    } else {
                      setViewConfirmation(true);
                    }
                  }}
                >
                  Assign Journey
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Modal>
      {viewConfirmation && <AssignJourneyToAllConfirmation submit={submit} close={() => setViewConfirmation(false)} />}
    </div>
  );
};
export default AssignJourneyDept;
